var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"qmod-toggle-wrap",class:_vm.enabled ? "qmod-toggle-on" : "qmod-toggle-off"},[_c('span',{staticClass:"qmod-toggle-text qmod-toggle-text-left"},[_vm._v(_vm._s(_vm.getEnabled))]),_c('span',{staticClass:"qmod-toggle-toggle"})])
}
var staticRenderFns = []

export { render, staticRenderFns }